import React, { useCallback, useEffect, useState } from 'react'

import { v4 as uniqid } from 'uuid'

import { FaDownload } from "react-icons/fa"

import DatePicker from '@/Form/V2/DatePicker'
import SubmitForm from '@/Form/V2/SubmitForm'
import Input      from '@/Form/V2/Input'

import getFormStatus from '@/Form/Functions/getFormStatus'

import bemit from '@function/bemit'

import Loader from '@Pure/Loader'

import FormsStore from '@Store/Forms'

const { moment } = window;

const FORM_NAME = 'ProductRefPdf';

export default function ProductRefPdfForm ({ product_ref, ...props })
{
	const [submit, setSubmit] = useState();
	const [submitting, setSubmitting] = useState(false);
	const [link, setLink] = useState('');
	const [status, setStatus] = useState({ });

	useEffect(function ()
	{
		if (product_ref)
		{
			FormsStore.update(function (store)
			{
				store[FORM_NAME] = { ref: product_ref };
			});
		}
	},
	[product_ref]);

	const sendForm = useCallback(function (e)
	{
		if (submitting) return;

		setLink('');

		FormsStore.update(function (store)
		{
			store[FORM_NAME]._submit_id = uniqid();
		});

		setSubmitting(true);
		setSubmit(uniqid());
	},
	[submitting]);

	const onError = useCallback(function (update)
	{
		setSubmit(undefined);
		setStatus(update);
		setSubmitting(false);
	},
	[]);

	const onSuccess = useCallback(function (response)
	{
		setSubmit(undefined);
		setStatus(response);
		setSubmitting(false);

		setLink(response.pathname);
	},
	[]);

	if (!product_ref) return null;

	const loader = submitting === true ?
	(
		<Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />
	)
	: undefined;

	return (
		<div className="o-form o-form--ref-example-pdf u-margin-top-20">

			<fieldset className="o-form__fieldset">

				<legend className="o-form__fieldset-legend">
					PDF d'exemple
				</legend>

				<div className="o-form__fieldset-content">

					<DatePicker name="limit_date"
						label="Date limite"
						form={ FORM_NAME }
						error={ status?.fields?.['limit_date']?.error }
						bemit={ ['auto'] }
					/>

					<Input name="label" label="Libellé"
						form={ FORM_NAME }
						error={ status?.fields?.['label']?.error }
						bemit={ ['25%'] }
					/>

					<Input name="code" label="Code"
						form={ FORM_NAME }
						error={ status?.fields?.['code']?.error }
						bemit={ ['25%'] }
					/>

					<Input name="web_code" label="Code web"
						form={ FORM_NAME }
						error={ status?.fields?.['web_code']?.error }
						bemit={ ['25%'] }
					/>

					<button type="button" className={ bemit('c-btn') +
						' u-margin-top-auto' }
						onClick={ sendForm }>
						Générer ce PDF d'exemple
						{ loader }
					</button>

					{
						link ?
						(
							<div className="u-full-width">
								<a href={ link } target="_blank" rel="noreferrer"
									onClick={ sendForm }
									className={ bemit('c-btn', ['green', 'icon']) }>
									<FaDownload className="c-btn__icon" />
									Télécharger l'exemple
								</a>
							</div>
						)
						: undefined
					}

				</div>

				{ getFormStatus(status) }

			</fieldset>

			{
				submit ?
				(
					<SubmitForm form={ FORM_NAME } id={ submit }
						key={ product_ref }
						onError={ onError }
						onSuccess={ onSuccess }
						url="/discount-codes/example-PDF"
					/>
				)
				: undefined
			}

		</div>
	);
}